module.exports = __webpack_public_path__ + "media/components/src/assets/images/top_img/intro-f29b945a679b2640fa9b7248f20f207f.webp";